<template>
  <div class="header-container">
    <div class="header-content">
      <div class="logo-view">
        <span class="logo-icon" />
        <span class="logo-text">点餐系统</span>
      </div>
      <div class="menu-view">
        <div class="nav">
          <router-link
            v-for="(item, index) in navItemDatas"
            :key="index"
            :to="item.url"
            class="nav-item"
          >
            {{ item.title }}
            <div
              :class="{ showicon: item.name === selectedItem }"
              class="icon-view"
            />
          </router-link>
        </div>
        <div class="user-view">
          <img @error="errorLoadImg()" :src="imgUrl" class="user-icon" />
          <span class="username">{{
            $store.state.user_info.employee_name
          }}</span>
          <img
            src="../../../static/img/header/icon_home_xl.png"
            class="arrow"
          />
          <PersonalCart class="personal-message" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalCart from "@/components/personal_cart";
import DEFAULT_IMG from "../../../static/img/header/user_icon.png";

export default {
  name: "Header",
  components: {
    PersonalCart,
  },
  data() {
    return {
      selectedItem: "lunch",
      username: "小菜鸟",
      // 导航列表数据源
      navItemDatas: [
        {
          title: "咖啡吧",
          name: "coffee",
          url: "/p/meals?type=coffee",
        },
        // {
        //   title: '早餐',
        //   name: 'breakfast',
        //   url: '/p/meals?type=breakfast'
        // },
        // {
        //   title: '下午茶',
        //   name: 'afternoon_tea',
        //   url: '/p/meals?type=afternoon_tea'
        // },
        {
          title: "今日加班餐",
          name: "overtime_meal",
          url: "/p/meals?type=overtime_meal",
        },
        {
          title: "明日午餐",
          name: "lunch",
          url: "/p/meals?type=lunch",
        },

        // {
        //   title: '试吃',
        //   name: 'try_eating',
        //   url: '/p/meals?type=try_eating'
        // }
      ],
    };
  },
  computed: {
    imgUrl() {
      return this.$store.state.avatar_url === ""
        ? DEFAULT_IMG
        : this.$store.state.avatar_url;
    },
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      this.changeNavigatorBar(to.query.type);
    },
  },
  mounted() {
    // 组件首次加载时判断相应路由，以展示相应内容
    this.changeNavigatorBar(location.search.split("=")[1]);
  },
  methods: {
    /**
     * 切换导航, 点餐列表默认午餐
     */
    changeNavigatorBar(key) {
      if (key) {
        this.selectedItem = key;
      }
    },
    /**
     * 默认图片
     */
    errorLoadImg() {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/header/user_icon.png";
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  width: 100%;
  min-width: 1200px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  .header-content {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .logo-view {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      .logo-icon {
        width: 54px;
        height: 54px;
        display: inline-block;
        background-image: url("../../../static/img/header/logo.png");
      }
      .logo-text {
        margin-left: 10px;
        font-size: 20px;
        color: #333333;
      }
    }
    .menu-view {
      width: 610px;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 18px;
      color: #333333;
      .nav {
        width: 300px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .nav-item {
          font-size: 18px;
          color: #333333;
          text-decoration: none;
          .icon-view {
            width: 100%;
            height: 4px;
            margin-top: -5px;
            visibility: hidden;
            background-color: #ff9a28;
          }
          .showicon {
            visibility: visible;
          }
          .showicon:hover {
            visibility: visible;
          }
        }
        .nav-item:hover {
          .icon-view {
            visibility: visible;
          }
        }
      }
      .user-view {
        width: 150px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        .user-icon {
          width: 36px;
          height: 36px;
          border-radius: 18px;
        }
        .username {
          margin-left: 5px;
          font-size: 18px;
          color: #333333;
        }
        .arrow {
          width: 12px;
          height: 8px;
          margin-left: 5px;
        }
        .personal-message {
          position: absolute;
          top: -700px;
          z-index: 1000;
          cursor: default;
        }
      }
      .user-view:hover .personal-message {
        top: 70px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue